import { TabBtns } from "../../Theme";
import { useNavigate } from "react-router-dom";
import { YSButton } from "../../uikit/YSButton";

export default function PendingRefillsTab(props: any) {
  const navigate = useNavigate();

  return (
    <TabBtns>
      <YSButton
        className={!props.activeRefillsTabClass ? "active tab" : "tab "}
        children={"Prescription Refill"}
        variant={"text"}
        size={"small"}
        onClick={() => {
          navigate("/pendingrefillsrequest");
          props.setActiveRefillsTabClass(false);
        }}
      />
      <YSButton
        className={props.activeRefillsTabClass ? "active tab" : "tab "}
        children={"Allergy Information"}
        variant={"text"}
        size={"small"}
        onClick={() => {
          navigate("/pendingrefillsrequest");
          props.setActiveRefillsTabClass(true);
        }}
      />{" "}
    </TabBtns>
  );
}
